export const passwordLengthValid = /^.{8,20}$/;
export const passwordRuleValid = /^\S+$/;
export const phoneCNValid = /^1\d{10}$/;
export const phoneIDValid = /^(8|08)\d{8,12}$/;
export const phoneTGValid = /^(6|8|9|06|08|09)\d{8}$/;
export const phontMLValid = /^(1|01)\d{7,9}$/;
export const emailRule = /^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/;
